import { cn } from "@/lib/cn";

/**
 * TK Vault mark: a vault door with a brass dial hub. Colors follow the active theme tokens.
 * Decorative next to the product name; give it a `label` when it stands alone.
 */
export function VaultMark({ className, label }: { className?: string; label?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      {...(label ? { role: "img", "aria-label": label } : { "aria-hidden": true })}
      focusable="false"
      className={cn("size-8 shrink-0", className)}
    >
      <rect x="2" y="2" width="28" height="28" rx="8" fill="var(--tv-primary)" />
      <rect x="2" y="9" width="2.5" height="4" rx="1" fill="var(--tv-primary-hover)" />
      <rect x="2" y="19" width="2.5" height="4" rx="1" fill="var(--tv-primary-hover)" />
      <circle cx="17" cy="16" r="7.5" fill="none" stroke="var(--tv-on-primary)" strokeWidth="2" />
      <path
        d="M17 16 L21.6 11.4 M17 16 L12.4 20.6 M17 16 L12.4 11.4 M17 16 L21.6 20.6"
        stroke="var(--tv-on-primary)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="17" cy="16" r="2.6" fill="var(--tv-accent)" />
    </svg>
  );
}
